import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_proveedores";

const getProveedoresPO = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const createProveedorPO = async (data, usuario) => {
  const response = await axios.post(`${baseUrl}${endpoint}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const updateProveedorPO = async (id, data, usuario) => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteProveedorPO = async (id, usuario) => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

export { getProveedoresPO, createProveedorPO, updateProveedorPO, deleteProveedorPO };
